import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {Collection} from "../../collection.model";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
    MatAutocomplete,
    MatAutocompleteSelectedEvent,
    MatAutocompleteTrigger,
    MatOption
} from "@angular/material/autocomplete";
import {MatFormField, MatFormFieldModule} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {TranslatePipe} from "@ngx-translate/core";
import {UserStub} from "../../../user/user-stub";
import {MatButton, MatIconButton} from "@angular/material/button";
import {UserService} from "../../../user/user.service";
import {debounceTime, distinctUntilChanged} from "rxjs";
import {CollectionService} from "../../collection.service";
import {MatIcon} from "@angular/material/icon";

@Component({
    selector: 'app-collection-transfer',
    imports: [
        FormsModule,
        MatAutocomplete,
        MatAutocompleteTrigger,
        MatFormField,
        MatInput,
        MatOption,
        ReactiveFormsModule,
        TranslatePipe,
        MatDialogContent,
        MatFormFieldModule,
        MatButton,
        MatIcon,
        MatIconButton
    ],
    templateUrl: './collection-transfer.component.html',
    styleUrl: './collection-transfer.component.scss'
})
export class CollectionTransferComponent {

    userSuggestions: UserStub[] = [];
    selectedUser: UserStub | null = null;

    userSearchForm: FormGroup;
    error: string | null = null;

    constructor(
        private userService: UserService,
        private collectionService: CollectionService,
        private dialogRef: MatDialogRef<CollectionTransferComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Collection,
        private fb: FormBuilder,
    ) {
        this.userSearchForm = this.fb.group({
            search: ['', []],
        });
        this.userSearchForm.controls['search'].valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
        ).subscribe((value) => {
            this.userService.search(value).subscribe(users => {
                this.userSuggestions = users;
            });
        });
    }

    displayUser(coll: UserStub) {
        return coll && coll.fullName ? coll.fullName : '';
    }

    selectUser($event: MatAutocompleteSelectedEvent) {
        this.selectedUser = $event.option.value;
    }

    canConfirm() {
        return this.selectedUser !== null;
    }

    confirm() {
        this.collectionService.transferOwnership([this.data.uuid], this.selectedUser!.id).subscribe({
            next: col => {
                this.dialogRef.close(col);
            },
            error: (e) => {
                console.error(e);
                this.error = 'error.unknown';
            }
        });
    }

    close() {
        this.dialogRef.close();
    }
}
